// Route-level error boundary — reports the error and offers a retry.
"use client";

import { useEffect } from "react";

import { reportRuntimeError } from "@/lib/monitoring/runtimeError";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportRuntimeError({ source: "next-route-error", error, digest: error.digest });
  }, [error]);

  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-xl font-bold">خطایی رخ داد</h1>
      <p className="max-w-md text-sm text-zinc-600">مشکلی در نمایش این صفحه پیش آمده است.</p>
      <button
        type="button"
        onClick={reset}
        className="rounded-md bg-zinc-900 px-4 py-2 text-sm text-white transition-colors hover:bg-zinc-700"
      >
        تلاش مجدد
      </button>
    </main>
  );
}
